import styled from 'styled-components';

export const Widget = styled.div`
    position: relative;
    & * {
        user-select: none;
    }
`;
